import { render, staticRenderFns } from "./GlobalIndicatorsView.vue?vue&type=template&id=38d6515f&"
import script from "./GlobalIndicatorsView.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsView.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalIndicatorsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports